import { IFlowyError, IUserV2 } from '../types';
import { parseDataToRealm, parseRealmToData } from './utils';
import {
  IConstructorParams,
  IDatabase,
  IDeleteAllParams,
  IDeleteParams,
  IGetParams,
  ISearchParams,
  ISetParams,
} from './utils/i-database';

class MemoryDatabase implements IDatabase {
  private _user: IUserV2;
  private _data: any = {};

  public constructor({ user }: IConstructorParams) {
    if (user) {
      this._user = user;
    } else {
      this._user = {
        id: 'anon',
        username: 'anon',
      };
    }
  }

  init(): Promise<void> {
    return new Promise<void>(resolve => {
      resolve();
    });
  }

  public setUser(user: IUserV2): void {
    this._user = user;
  }

  public set({ type, value, isMainForm, update }: ISetParams): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const parsedData = parseDataToRealm({
        type,
        data: value,
        user: this._user,
        isMainForm,
      });

      if (!this._data[type]) {
        this._data[type] = [];
      }
      const index = this._data[type].findIndex(
        (v: any) => v.fid === parsedData.fid
      );

      if (index !== -1) {
        if (update) {
          this._data[type][index] = parsedData;
        } else {
          // Raise exception
          const error: IFlowyError = {
            origin: 'database',
            message: `The ${type} with fid ${parsedData.fid} already exists`,
          };
          return reject(error);
        }
      } else {
        this._data[type].push(parsedData);
      }

      resolve();
    });
  }

  public get({ type, fid }: IGetParams): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this._data[type]) {
        const result = this._data[type].find((v: any) => v.fid === fid);

        if (result) {
          const parsedData = parseRealmToData({
            type,
            data: result,
          });

          return resolve(parsedData);
        }
      }

      const error: IFlowyError = {
        origin: 'database',
        code: 'db.not-found',
        message: `The ${type} with fid ${fid} does not exist`,
      };
      reject(error);
    });
  }

  search({ type, params }: ISearchParams): Promise<any[]> {
    // throw new Error('Method not implemented.');
    return new Promise<any[]>(resolve => {
      const results = (this._data[type] || [])
        .filter((v: any) => {
          let r = true;

          for (const key in params) {
            if (v[key] !== params[key]) {
              r = false;
            }
          }

          return r;
        })
        .map((v: any) => parseRealmToData({ type, data: v }));

      resolve(results);
    });
  }

  deleteAll({ type }: IDeleteAllParams): Promise<void> {
    return new Promise<void>(async resolve => {
      delete this._data[type];
      resolve();
    });
  }

  // We have to use remove method because delete is a reserved word in Dexie
  delete({ type, fid }: IDeleteParams): Promise<void> {
    return new Promise<void>(async resolve => {
      if (this._data[type]) {
        this._data[type] = this._data[type].filter((v: any) => v.fid !== fid);
      }

      resolve();
    });
  }
}

export default MemoryDatabase;
